import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import Cell from '@components/Cell';
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "cursor"
    }}>{`Cursor`}</h1>
    <p>{`Utility classes to change pointer behaviour`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class reference`}</h2>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.o-0</Name>
        <Output mdxType="Output">opacity: 0</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-10</Name>
        <Output mdxType="Output">opacity: 10%</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-20</Name>
        <Output mdxType="Output">opacity: 20%</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-30</Name>
        <Output mdxType="Output">opacity: 30%</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-40</Name>
        <Output mdxType="Output">opacity: 40%</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-50</Name>
        <Output mdxType="Output">opacity: 50%</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-60</Name>
        <Output mdxType="Output">opacity: 60%</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-70</Name>
        <Output mdxType="Output">opacity: 70%</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-80</Name>
        <Output mdxType="Output">opacity: 80%</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-90</Name>
        <Output mdxType="Output">opacity: 90%</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-100</Name>
        <Output mdxType="Output">opacity: 100%</Output>
    </Property>
    </Reference>
    <h2 {...{
      "id": "opacity"
    }}>{`Opacity`}</h2>
    <p><inlineCode parentName="p">{`.o-{value}`}</inlineCode>{` changes the opacity of the element it is applied on.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <Cell className="o-0" mdxType="Cell">.o-0</Cell>
    <Cell className="o-10" mdxType="Cell">.o-10</Cell>
    <Cell className="o-20" mdxType="Cell">.o-20</Cell>
    <Cell className="o-30" mdxType="Cell">.o-30</Cell>
    <Cell className="o-40" mdxType="Cell">.o-40</Cell>
    <Cell className="o-50" mdxType="Cell">.o-50</Cell>
    <Cell className="o-60" mdxType="Cell">.o-60</Cell>
    <Cell className="o-70" mdxType="Cell">.o-70</Cell>
    <Cell className="o-80" mdxType="Cell">.o-80</Cell>
    <Cell className="o-90" mdxType="Cell">.o-90</Cell>
    <Cell className="o-100" mdxType="Cell">.o-100</Cell>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="o-0">...</div>
    <div className="o-10">...</div>
    <div className="o-20">...</div>
    <div className="o-30">...</div>
    <div className="o-40">...</div>
    <div className="o-50">...</div>
    <div className="o-60">...</div>
    <div className="o-70">...</div>
    <div className="o-80">...</div>
    <div className="o-90">...</div>
    <div className="o-100">...</div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      